export const SCAN_SITE_UPDATED = 'scanSiteUpdated';
